// extracted by mini-css-extract-plugin
module.exports = {"container":"i_AA","dark":"i_AB","icon":"i_AC","light":"i_AD"};